import MarkdownLexer from "./markdown-lexer";

const parseLink = (token) => {
    const REGEX_LINK = /\[(.+)\]\((.+)\)/;
    let [_, name, url] = token.value.match(REGEX_LINK);

    // Always default to https
    if (url.startsWith('http://')) {
        url = url.replace('http://', 'https://');
    } else if (!url.startsWith('https://')) {
        url = 'https://' + url;
    }

    return m('a', { href: url, target: '_blank' }, name);
};

const parseText = (token) => {
    return token.value;
};

/**
 * Mithril Markdown Parser
 * 
 * Parse text into mithril vnodes, uses MarkdownLexer's tokens for processing.
 * 
 * @see MarkdownLexer
 * @author Darrus Goh
 */
const MithrilMarkdownParser = {
    parse: (text) => {
        const tokens = MarkdownLexer.analyze(text);
        return m('p.m-0', { style: { 'white-space': 'pre-wrap' } },
            tokens.map(token => {
                switch (token.type) {
                    case MarkdownLexer.TOKEN_TYPES.TEXT:
                        return parseText(token);
                    case MarkdownLexer.TOKEN_TYPES.LINK:
                        return parseLink(token);
                }
            })
        );
    }
};

export default MithrilMarkdownParser;